<template>
  <a-modal v-model="visible" width="1000px" :destroyOnClose="true" @close="handleClose" title="统计" :maskClosable="false" :bodyStyle="{ padding: '16px 24px' }">
    <!-- 筛选区域：时间选择 + 快捷按钮 + 切换开关 -->
    <div class="stat-filter-bar">
      <div class="stat-filter-left">
        <span class="stat-filter-label">交易时间：</span>
        <a-range-picker v-model="searchtime" valueFormat="YYYY-MM-DD" @change="onChange" class="stat-date-picker" />
        <a-radio-group v-model="datater" @change="dataonChange" size="small" class="stat-quick-btns">
          <a-radio-button :value="1">今天</a-radio-button>
          <a-radio-button :value="2">昨天</a-radio-button>
          <a-radio-button :value="3">近七天</a-radio-button>
          <a-radio-button :value="4">当月</a-radio-button>
          <a-radio-button :value="5">上月</a-radio-button>
        </a-radio-group>
        <a-button type="primary" size="small" :loading="loading" @click="fetchData">查询</a-button>
      </div>
      <div class="stat-filter-right">
        <span class="stat-filter-label">区分对方账号</span>
        <a-switch v-model="pvAcctNo" />
      </div>
    </div>

    <div ref="pvExportArea">
      <!-- 账户信息卡片 -->
      <div class="stat-info-card">
        <div class="stat-info-item">
          <span class="stat-info-label">账户名称</span>
          <span class="stat-info-value">{{ queryParams.account_name || '-' }}</span>
        </div>
        <div class="stat-info-divider" />
        <div class="stat-info-item">
          <span class="stat-info-label">账号</span>
          <span class="stat-info-value">{{ queryParams.account_no || '-' }}</span>
        </div>
        <div class="stat-info-divider" />
        <div class="stat-info-item">
          <span class="stat-info-label">时间范围</span>
          <span class="stat-info-value">{{ form.start_date }} ~ {{ form.end_date }}</span>
        </div>
      </div>

      <!-- 数据表格 -->
      <a-spin :spinning="loading" tip="加载中...">
        <a-table
            :columns="detailPVColumn"
            :data-source="detailPVData"
            size="small"
            :pagination="false"
            :locale="{ emptyText: '暂无流水数据' }"
            class="stat-table"
        />
      </a-spin>

      <!-- 汇总统计 -->
      <div class="stat-summary">
        <div class="stat-summary-item stat-summary-income">
          <span class="stat-summary-label">总收入</span>
          <span class="stat-summary-count">{{ summaryPVData.dCount }}笔</span>
          <Balance :amount="summaryPVData.dSum" dcflag="d" :inline="true" class="stat-summary-amount" />
        </div>
        <div class="stat-summary-divider" />
        <div class="stat-summary-item stat-summary-expense">
          <span class="stat-summary-label">总支出</span>
          <span class="stat-summary-count">{{ summaryPVData.cCount }}笔</span>
          <Balance :amount="summaryPVData.cSum" dcflag="c" :inline="true" class="stat-summary-amount" />
        </div>
      </div>
    </div>

    <template slot="footer">
      <div class="stat-footer">
        <div class="stat-footer-left">
          <a-button type="link" @click="exportPVAsPDF">
            <a-icon type="download" />下载PDF
          </a-button>
          <a-button type="link" @click="exportPvDataToExcel">
            <a-icon type="download" />下载Excel
          </a-button>
        </div>
        <a-button @click="visible = false">关闭</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import dayjs from 'dayjs';
import {groupBy} from '@/utils/commonMethods';
import {utils, writeFile} from 'xlsx';
import Balance from '@/view/components/Balance.vue';
import {message} from 'ant-design-vue';

export default {
  name: 'AccountStatView',
  components: {Balance},
  props: {
    /** 查询参数：channel_no, app_no, account_no, account_name */
    queryParams: {
      type: Object,
      required: true,
    },
    /** 默认起始日期，为空则使用近7天 */
    defaultStartDate: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      loading: false,
      datater: null,
      searchtime: [],
      form: {
        page: 0,
        start_date: '',
        end_date: '',
      },
      data: [],
      pvAcctNo: false,
    };
  },
  computed: {
    detailPVColumn() {
      const columns = [
        {
          title: '交易类型',
          dataIndex: 'trans_type',
          align: 'center',
          width: 100,
          customRender: (text) => {
            const typeMap = {
              '0': '其他', '1': '开户', '2': '修改', '3': '销户',
              '4': '存款', '5': '取款', '6': '转入', '7': '转出', '8': '撤销',
            };
            return typeMap[String(text)] || text;
          },
        },
        {
          title: '对方户名',
          dataIndex: 'opp_account_name',
          align: 'center',
          width: 200,
          ellipsis: true,
        },
        ...(this.pvAcctNo
            ? [
              {
                title: '对方账号',
                dataIndex: 'opp_account_no',
                align: 'center',
                width: 200,
                ellipsis: true,
              },
            ]
            : []),
        {
          title: '交易备注',
          dataIndex: 'remark',
          align: 'center',
          width: 300,
          ellipsis: true,
        },
        {
          title: '交易金额合计',
          dataIndex: '合计#trans_amount',
          align: 'center',
          width: 140,
          customRender: (text, row) => {
            let dcflag = '';
            if (['4', '6'].indexOf(row.trans_type) >= 0) dcflag = 'd';
            if (['5', '7'].indexOf(row.trans_type) >= 0) dcflag = 'c';
            return <Balance amount={text} dcflag={dcflag}/>;
          },
        },
      ];
      return columns;
    },
    detailPVData() {
      const groups = [this.pvAcctNo ? 'opp_account_no' : ''].filter(Boolean);
      const pvData = groupBy(
          this.data ?? [],
          ['trans_type', 'remark', 'opp_account_name', ...groups],
          {sum: ['trans_amount']},
      )
          .filter((item) => item['合计#trans_amount'])
          .sort((a, b) => {
            if (a.trans_type === b.trans_type) return a['合计#trans_amount'] - b['合计#trans_amount'];
            return Number(a.trans_type) - Number(b.trans_type);
          });
      return pvData;
    },
    summaryPVData() {
      let dCount = 0, dSum = 0, cCount = 0, cSum = 0;
      (this.data ?? []).forEach((item) => {
        if (['4', '6'].indexOf(item.trans_type) >= 0) {
          dCount++;
          dSum += Number(item.trans_amount);
        } else if (['5', '7'].indexOf(item.trans_type) >= 0) {
          cCount++;
          cSum += Number(item.trans_amount);
        }
      });
      return {dCount, dSum, cCount, cSum};
    },
  },
  methods: {
    /** 外部调用：打开弹窗 */
    show() {
      this.initDateRange();
      this.visible = true;
      this.$nextTick(() => {
        this.fetchData();
      });
    },
    /** 初始化时间范围 */
    initDateRange() {
      if (this.defaultStartDate) {
        this.form.start_date = this.defaultStartDate;
      } else {
        this.form.start_date = dayjs().subtract(7, 'day').format('YYYY-MM-DD');
      }
      this.form.end_date = dayjs().format('YYYY-MM-DD');
      this.searchtime = [this.form.start_date, this.form.end_date];
      this.datater = null;
    },
    /** 获取交易流水数据 */
    async fetchData() {
      if (!this.queryParams.account_no) {
        message.warning('缺少个体户账号，无法查询');
        return;
      }
      this.loading = true;
      try {
        const params = {
          ...this.queryParams,
          page: 0,
          start_date: this.form.start_date,
          end_date: this.form.end_date,
        };
        const res = await this.api.queryTradeDetailApi(params);
        if (res.code !== 200) {
          message.error(res.info || '获取流水数据失败');
          this.data = [];
          return;
        }
        this.data = res.data.detail_list || [];
      } catch (error) {
        console.error('获取流水数据失败:', error);
        message.error('获取流水数据失败');
        this.data = [];
      } finally {
        this.loading = false;
      }
    },
    /** 便捷日期按钮切换 */
    dataonChange($event) {
      this.searchtime[0] = dayjs().format('YYYY-MM-DD');
      if ($event.target.value === 1) {
        this.form.start_date = dayjs().format('YYYY-MM-DD');
        this.form.end_date = dayjs().format('YYYY-MM-DD');
      } else if ($event.target.value === 2) {
        this.form.start_date = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
        this.form.end_date = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
      } else if ($event.target.value === 3) {
        this.form.start_date = dayjs().subtract(7, 'day').format('YYYY-MM-DD');
        this.form.end_date = dayjs().format('YYYY-MM-DD');
      } else if ($event.target.value === 4) {
        this.form.start_date = dayjs().startOf('month').format('YYYY-MM-DD');
        this.form.end_date = dayjs().format('YYYY-MM-DD');
      } else if ($event.target.value === 5) {
        this.form.start_date = dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
        this.form.end_date = dayjs(this.form.start_date).endOf('month').format('YYYY-MM-DD');
      }
      this.searchtime = [this.form.start_date, this.form.end_date];
      this.fetchData();
    },
    /** 日期选择器变更 */
    onChange() {
      this.form.start_date = this.searchtime[0];
      this.form.end_date = dayjs(this.searchtime[1]).format('YYYY-MM-DD');
      this.datater = null;
    },
    /** 关闭时重置状态 */
    handleClose() {
      this.data = [];
      this.pvAcctNo = false;
    },
    /** 导出 Excel */
    exportPvDataToExcel() {
      if (!this.detailPVData || this.detailPVData.length === 0) {
        message.warning('暂无可导出的数据');
        return;
      }
      const wb = utils.book_new();
      const ws = utils.aoa_to_sheet([]);
      const infoRows = [
        [`账户名称：${this.queryParams.account_name || '-'}`, `账号：${this.queryParams.account_no || '-'}`, `时间：${this.form.start_date} ~ ${this.form.end_date}`],
        [],
      ];
      utils.sheet_add_aoa(ws, infoRows, {origin: 'A1'});
      const tableHeaders = this.detailPVColumn.map((col) => col.title);
      utils.sheet_add_aoa(ws, [tableHeaders], {origin: `A${infoRows.length + 1}`});
      const dataRows = this.detailPVData.map((row) =>
          this.detailPVColumn.map((col) => {
            const val = row[col.dataIndex];
            if (typeof val === 'number') return val;
            if (typeof val === 'string') return val.trim();
            return val ?? '';
          }),
      );
      utils.sheet_add_aoa(ws, dataRows, {origin: `A${infoRows.length + 2}`});
      const summaryRow = [
        [`收入笔数`, `${this.summaryPVData.dCount}`, `收入金额`, `${this.summaryPVData.dSum}`],
        [`支出笔数`, `${this.summaryPVData.cCount}`, `支出金额`, `${this.summaryPVData.cSum}`],
      ];
      utils.sheet_add_aoa(ws, summaryRow, {origin: `A${infoRows.length + dataRows.length + 3}`});
      const colWidths = new Array(tableHeaders.length).fill(0);
      const allRows = [tableHeaders, ...dataRows, ...summaryRow];
      allRows.forEach((row) => {
        row.forEach((cell, i) => {
          const cellWidth = cell ? [...String(cell)].reduce((acc, char) => acc + (char.match(/[\u4e00-\u9fa5]/) ? 2 : 1), 0) : 0;
          if (cellWidth > colWidths[i]) colWidths[i] = cellWidth;
        });
      });
      ws['!cols'] = colWidths.map((width) => ({wch: Math.min(width + 2, 50)}));
      utils.book_append_sheet(wb, ws, '统计');
      const filename = `统计-${this.queryParams.account_name || '未命名'}-${dayjs().format('YYYY-MM-DD')}.xlsx`;
      writeFile(wb, filename);
      message.success('导出成功');
    },
    /** 导出 PDF */
    async exportPVAsPDF() {
      if (!this.visible) {
        message.warning('请先打开统计弹窗');
        return;
      }
      message.info('正在生成PDF，请稍候...');
      await this.$nextTick();
      const element = this.$refs.pvExportArea;
      if (!element) {
        message.error('未找到导出节点');
        return;
      }
      try {
        const html2canvas = (await import('html2canvas')).default;
        const jsPDF = (await import('jspdf')).default;
        const pdf = new jsPDF({orientation: 'p', unit: 'mm', format: 'a4'});
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const margin = 15;
        const canvas = await html2canvas(element, {scale: 2, useCORS: true, allowTaint: true, backgroundColor: '#ffffff'});
        const imgData = canvas.toDataURL('image/jpeg', 1.0);
        const imgProps = pdf.getImageProperties(imgData);
        const imgWidth = pageWidth - margin * 2;
        const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
        let position = margin;
        if (imgHeight < pageHeight - margin * 2) {
          pdf.addImage(imgData, 'JPEG', margin, position, imgWidth, imgHeight);
        } else {
          let remainingHeight = imgHeight;
          let pageCount = 0;
          const canvasHeight = canvas.height;
          const pageCanvasHeight = ((pageHeight - margin * 2) / imgHeight) * canvasHeight;
          while (remainingHeight > 0) {
            const pageCanvas = document.createElement('canvas');
            pageCanvas.width = canvas.width;
            pageCanvas.height = pageCanvasHeight;
            const ctx = pageCanvas.getContext('2d');
            ctx.fillStyle = '#FFFFFF';
            ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
            ctx.drawImage(canvas, 0, pageCount * pageCanvasHeight, canvas.width, pageCanvasHeight, 0, 0, canvas.width, pageCanvasHeight);
            const pageData = pageCanvas.toDataURL('image/jpeg', 1.0);
            if (pageCount > 0) pdf.addPage();
            pdf.addImage(pageData, 'JPEG', margin, margin, imgWidth, pageHeight - margin * 2);
            remainingHeight -= pageHeight - margin * 2;
            pageCount++;
          }
        }
        pdf.save(`统计-${this.queryParams.account_name || '未命名'}-${dayjs().format('YYYY-MM-DD')}.pdf`);
        message.success('PDF导出成功');
      } catch (e) {
        console.error('PDF导出失败:', e);
        message.error('PDF导出失败，请检查html2canvas/jspdf依赖是否安装');
      }
    },
  },
};
</script>

<style scoped>
/* ===== 筛选栏 ===== */
.stat-filter-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 14px;
  padding: 10px 12px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
}
.stat-filter-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.stat-filter-right {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.stat-filter-label {
  font-size: 13px;
  color: #333;
  font-weight: 500;
}
.stat-date-picker {
  width: 210px;
}
.stat-quick-btns .ant-radio-button-wrapper {
  font-size: 12px;
  padding: 0 10px;
}

/* ===== 账户信息卡片 ===== */
.stat-info-card {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  margin-bottom: 12px;
  background: linear-gradient(135deg, #f0f5ff 0%, #e6f7ff 100%);
  border: 1px solid #d6e4ff;
  border-radius: 6px;
}
.stat-info-item {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.stat-info-label {
  font-size: 12px;
  color: #666;
  white-space: nowrap;
}
.stat-info-value {
  font-size: 13px;
  color: #1a1a1a;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.stat-info-divider {
  width: 1px;
  height: 24px;
  background: #d6e4ff;
  margin: 0 16px;
  flex-shrink: 0;
}

/* ===== 表格 ===== */
.stat-table {
  margin-bottom: 0;
}
.stat-table /deep/ .ant-table-thead > tr > th {
  background: #f7f9fc;
  font-weight: 600;
  font-size: 12px;
  color: #333;
  padding: 6px 8px;
}
.stat-table /deep/ .ant-table-tbody > tr > td {
  padding: 5px 8px;
}

/* ===== 汇总统计 ===== */
.stat-summary {
  display: flex;
  align-items: center;
  margin-top: 10px;
  padding: 10px 16px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
}
.stat-summary-item {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
}
.stat-summary-label {
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}
.stat-summary-income .stat-summary-label {
  color: #52c41a;
}
.stat-summary-expense .stat-summary-label {
  color: #ff4d4f;
}
.stat-summary-count {
  font-size: 13px;
  color: #333;
  white-space: nowrap;
}
.stat-summary-amount {
  font-size: 13px;
  font-weight: 600;
}
.stat-summary-divider {
  width: 1px;
  height: 28px;
  background: #e8e8e8;
  margin: 0 20px;
  flex-shrink: 0;
}

/* ===== 底部操作栏 ===== */
.stat-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-right: 8px;
}
.stat-footer-left {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>
